// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Akvp","buttons":"Footer_buttons__9FgBo"};